export default {
    name: 'theme_module',
    state: {
        currentTheme: (function() {
            try {
                const saved = localStorage.getItem('theme');
                if (saved === 'light' || saved === 'dark') return saved;
                if (typeof window !== 'undefined' && window.matchMedia) {
                    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
                }
            } catch (_) {}
            return 'light';
        })()
    },
    getters: {
        getCurrentTheme: (state) => state.currentTheme
    },
    mutations: {
        setTheme: (state, theme) => {
            state.currentTheme = theme;
            try {
                document.documentElement.setAttribute('data-theme', theme);
                localStorage.setItem('theme', theme);
            } catch (_) {}
        }
    },
    actions: {
        initializeTheme({ commit }) {
            try {
                const saved = localStorage.getItem('theme');
                if (saved === 'light' || saved === 'dark') {
                    commit('setTheme', saved);
                    return;
                }
                if (typeof window !== 'undefined' && window.matchMedia) {
                    const mq = window.matchMedia('(prefers-color-scheme: dark)');
                    commit('setTheme', mq.matches ? 'dark' : 'light');
                    if (typeof mq.addEventListener === 'function') {
                        mq.addEventListener('change', (e) => commit('setTheme', e.matches ? 'dark' : 'light'));
                    } else if (typeof mq.addListener === 'function') {
                        mq.addListener((e) => commit('setTheme', e.matches ? 'dark' : 'light'));
                    }
                    return;
                }
            } catch (_) {}
            commit('setTheme', 'light');
        },
        toggleTheme({ commit, state }) {
            const newTheme = state.currentTheme === 'light' ? 'dark' : 'light';
            commit('setTheme', newTheme);
        }
    }
} 